var ROUTER_V2 = '0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D';
export var ROUTER_V2_ADDRESS = {
    '1': ROUTER_V2,
    '10': '0x4A7b5Da61326A6379179b40d00F57E5bbDC962c2',
    '42161': '0x4752ba5dbc23f44d87826276bf6fd6b1c372ad24',
    '8453': '0x4752ba5dbc23f44d87826276bf6fd6b1c372ad24',
    '11155111': '0xeE567Fe1712Faf6149d80dA1E6934E354124CfE3',
};
export var ROUTER_V2_ADDRESSES = [
    { address: ROUTER_V2, chainId: 1 },
    { address: '0x4A7b5Da61326A6379179b40d00F57E5bbDC962c2', chainId: 10 },
    { address: '0x4752ba5dbc23f44d87826276bf6fd6b1c372ad24', chainId: 42161 },
    { address: '0x4752ba5dbc23f44d87826276bf6fd6b1c372ad24', chainId: 8453 },
    { address: '0xeE567Fe1712Faf6149d80dA1E6934E354124CfE3', chainId: 11155111 },
];
export var FACTORY_V2_ADDRESSES = [
    {
        chainId: 1,
        address: '0x5C69bEe701ef814a2B6a3EDD4B1652CB9cc5aA6f',
    },
    {
        chainId: 10,
        address: '0x0c3c1c532F1e39EdF36BE9Fe0bE1410313E074Bf',
    },
    {
        chainId: 8453,
        address: '0x8909Dc15e40173Ff4699343b6eB8132c65e18eC6',
    },
    {
        chainId: 42161,
        address: '0xf1D7CC64Fb4452F05c498126312eBE29f30Fbcf9',
    },
    {
        chainId: 11155111,
        address: '0xF62c03E08ada871A0bEb309762E260a7a6a880E6',
    },
];
